/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import { FormattedMessage, type MessageDescriptor } from 'react-intl-next';

import { Y75 } from '@atlaskit/adf-schema';
import Tooltip from '@atlaskit/tooltip';

/*
  Converts an input set of unicode characters into a map that has the characters as the key and their code point as the value
  Ex: ('\u206b') -> {'\u206b': "<U206B>"} 
*/
export function setToUnicodeMap(char_set: Set<string>): Map<string, string> {
  const unicodeMap = new Map();
  char_set.forEach(char => {
    const codePoint = char.codePointAt(0)?.toString(16);
    unicodeMap.set(
      char,
      `<U${codePoint?.padStart(codePoint.length <= 4 ? 4 : 8, '0')}>`
    );
  });
  return unicodeMap;
}

export function characterReplacer(
  charMap: Map<string, string>,
  tooltip?: MessageDescriptor
): any {
  const regEx = new RegExp(`[${Array.from(charMap.keys()).join('')}]`, 'gu');

  const htmlReplace = (html: string) => {
    return html.replace(regEx, function (match: string): string {
      return charMap.get(match) || '';
    });
  };

  const UnicodeReplacement = ({ str }: { str: string }) => {
    if (tooltip) {
      return (
        <Tooltip content={<FormattedMessage {...tooltip} />} tag="span">
          <span style={{ backgroundColor: Y75 }}>{str}</span>
        </Tooltip>
      );
    } else {
      return <span style={{ backgroundColor: Y75 }}>{str}</span>;
    }
  };
  return [regEx, htmlReplace, UnicodeReplacement];
}
